// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"60daedf9","977":"f140f3b3"}[chunkId] + ".chunk.js";
};